import type { AgeGroupWithPrice } from "@/components/ProductCard"
import type { SelectedProduct } from "@/types/Product"

export type ProductInfo = {
  productId: string
  productName: string
  idImageRequired: boolean
  isSubscriptionProduct: boolean
  personCertificateRequired: boolean
  bookingLengthInDays: number
  showFreeSkiDays: boolean
  subscriptionConfigurationId: string | null
  resortId: number
}

export const toProductInfo = (product: {
  id: string
  name: string
  idImageRequired: boolean
  isSubscriptionProduct: boolean
  personCertificateRequired: boolean
  bookingLength: number
  showFreeSkiDays: boolean
  subscriptionConfigurationId: string | null
  resortId: number
}): ProductInfo => ({
  productId: product.id,
  productName: product.name,
  idImageRequired: product.idImageRequired,
  isSubscriptionProduct: product.isSubscriptionProduct,
  personCertificateRequired: product.personCertificateRequired,
  bookingLengthInDays: product.bookingLength,
  showFreeSkiDays: product.showFreeSkiDays,
  subscriptionConfigurationId: product.subscriptionConfigurationId,
  resortId: product.resortId,
})

export const buildSelectedProduct = (
  product: ProductInfo,
  ageGroup: AgeGroupWithPrice
): Omit<SelectedProduct, "quantity"> => ({
  productPriceId: ageGroup.productId,
  productName: product.productName,
  ageGroup: ageGroup.name,
  price: ageGroup.price?.discountedPrice
    ? ageGroup.price.discountedPrice.price
    : (ageGroup.price?.onlinePrice ?? 0),
  idImageRequired: product.idImageRequired,
  isSubscriptionProduct: product.isSubscriptionProduct,
  personCertificateRequired: product.personCertificateRequired,
  priceSuffix: ageGroup.price?.suffix ?? "",
  productId: product.productId,
  minAge: ageGroup.minAge,
  maxAge: ageGroup.maxAge,
  bookingLengthInDays: product.bookingLengthInDays,
  showFreeSkiDays: product.showFreeSkiDays,
  subscriptionConfigurationId: product.subscriptionConfigurationId,
  resortId: product.resortId,
  analyticsId: ageGroup.analyticsId,
  analyticsName: ageGroup.analyticsName,
})
